module.exports = __webpack_public_path__ + "img/stahlgelaender.d14a5ea1.jpg";